class ScrollFade extends HTMLElement {
  maxScroll = 8;
  gradientTop = this.querySelector('[data-gradient-top]');
  gradientBottom = this.querySelector('[data-gradient-bottom]');

  connectedCallback() {
    // Init
    this.gradientTop.style.opacity = 0;
    this.gradientBottom.style.opacity = 1;

    // Look for events
    this.addEventListener('scroll', () => this.handleScroll());
  }

  disconnectedCallback() {
    this.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    console.log('> handleScroll');
    const scrollTop = this.scrollTop;

    // Calculate opacity for top gradient
    const opacityTop = Math.min(scrollTop / this.maxScroll, 1);

    // Calculate remaining scroll distance to bottom
    const remainingScroll = this.scrollHeight - this.clientHeight - scrollTop;

    // Calculate opacity for bottom gradient
    const opacityBottom = remainingScroll <= 0 ? 0 : Math.min(remainingScroll / this.maxScroll, 1);

    if (this.gradientTop) this.gradientTop.style.opacity = opacityTop;
    if (this.gradientBottom) this.gradientBottom.style.opacity = opacityBottom;
  }
}

customElements.define('scroll-fade', ScrollFade);
